<script setup lang='ts'>
import { isClient } from '@qcwp/utils'
import type { MaybeComputedRef } from '@vueuse/core'
import type { ListState } from '@qcwp/common'
import { useCustomInfiniteScroll } from './hooks/useInfiniteScroll'
const props = withDefaults(defineProps<{
  state?: ListState
  el?: MaybeComputedRef<HTMLElement | Window | Document | SVGElement | null | undefined>
  direction?: 'top' | 'bottom' | 'left' | 'right'
  offset?: number
  finishedText?: string
  loadingText?: string
  loadText?: string
  errorText?: string
}>(), {
  state: 'load',
  direction: 'bottom',
  offset: 10,
  finishedText: '没有更多了',
  loadingText: '加载中...',
  loadText: '加载更多',
  errorText: '加载失败',
})

const emits = defineEmits({
  'update:state': (state: ListState) => typeof state === 'string',
  'load': () => true,
})
const DEFAULT_ELEMENT = ref(isClient ? document : null)

const stateText = computed(() => props[`${props.state}Text`])
const loadStateRef = ref<HTMLElement | null>(null)
const loadStateVisible = useElementVisibility(loadStateRef)

function loadHandle() {
  if (!['load', 'error'].includes(props.state))
    return
  emits('load')
}

const el = props.el || DEFAULT_ELEMENT
let scrollStop: any = null
let watchStopHandle: any = null
let loadStateVisibleWatch: any = null

function removeScrollEvent() {
  watchStopHandle?.()
  scrollStop?.()
  loadStateVisibleWatch?.()
}
function watchInit() {
  watchStopHandle = watchEffect(() => {
    scrollStop?.()
    scrollStop = useCustomInfiniteScroll(
      el,
      loadHandle,
      { distance: props.offset, direction: props.direction },
    )
  })
  loadStateVisibleWatch = watch(loadStateVisible, (show) => {
    show && loadHandle()
  })
}

isClient && watchInit()
onActivated(watchInit)
onUnmounted(removeScrollEvent)
onDeactivated(removeScrollEvent)
</script>

<template>
  <div v-bind="$attrs" class="list-wrapper">
    <slot />
  </div>
  <div ref="loadStateRef" class="pt-3 pb-4 flex items-center justify-center cursor-pointer" @click="loadHandle">
    <van-loading v-if="props.state === 'loading'" size="16" mr-2 />
    <span class="text-title-400">{{ stateText }}</span>
  </div>
</template>
